namespace TabAurous.Common {
    export interface ProductEnquiryForm {
        ProductId: Serenity.StringEditor;
        ProductEnquiryType: OMS.ProductEnquiryTypesEditor;
        SearchSKU: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ItemTypeId: Serenity.IntegerEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        MFAmount: Serenity.DecimalEditor;
        DiamondDiscountPercent: Serenity.DecimalEditor;
        AttributeId: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsNew: Serenity.BooleanEditor;
        IsFeatured: Serenity.BooleanEditor;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        Purity: Serenity.DecimalEditor;
        IsDefaultSKU: Serenity.BooleanEditor;
        SKU: Serenity.StringEditor;
        Remarks: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        Image1: Serenity.ImageUploadEditor;
        Image2: Serenity.ImageUploadEditor;
        Image3: Serenity.ImageUploadEditor;
        BOMDetails: OMS.ProductBOMEditor;
        LaborDetails: OMS.ProductMasterLaborEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Variance: Serenity.DecimalEditor;
        PointerWeight: Serenity.DecimalEditor;
        Rate: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: Serenity.DecimalEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: Serenity.DecimalEditor;
    }

    export class ProductEnquiryForm extends Serenity.PrefixedContext {
        static formKey = 'Common.ProductEnquiry';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductEnquiryForm.init)  {
                ProductEnquiryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = OMS.ProductEnquiryTypesEditor;
                var w2 = s.LookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = CommonCategoryLookup;
                var w5 = CommonSubCategoryLookup;
                var w6 = s.DecimalEditor;
                var w7 = s.BooleanEditor;
                var w8 = CommonProductSizeLookup;
                var w9 = s.ImageUploadEditor;
                var w10 = OMS.ProductBOMEditor;
                var w11 = OMS.ProductMasterLaborEditor;

                Q.initFormType(ProductEnquiryForm, [
                    'ProductId', w0,
                    'ProductEnquiryType', w1,
                    'SearchSKU', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'ProductTypeId', w2,
                    'ItemTypeId', w3,
                    'CategoryId', w4,
                    'SubCategoryId', w5,
                    'BrandId', w2,
                    'CollectionId', w2,
                    'SuperTypeId', w2,
                    'MFAmount', w6,
                    'DiamondDiscountPercent', w6,
                    'AttributeId', w0,
                    'CalcOnId', w2,
                    'CalcUnitId', w2,
                    'HSN', w2,
                    'TaxCode', w2,
                    'IsDisabled', w7,
                    'IsNew', w7,
                    'IsFeatured', w7,
                    'HasBom', w7,
                    'MetalId', w2,
                    'KaratId', w2,
                    'MetalColorId', w2,
                    'ProductSizeId', w8,
                    'Purity', w6,
                    'IsDefaultSKU', w7,
                    'SKU', w0,
                    'Remarks', w0,
                    'ImageName', w9,
                    'Image1', w9,
                    'Image2', w9,
                    'Image3', w9,
                    'BOMDetails', w10,
                    'LaborDetails', w11,
                    'Pieces', w3,
                    'Weight', w6,
                    'NetWeight', w6,
                    'Variance', w6,
                    'PointerWeight', w6,
                    'Rate', w6,
                    'UnitLabour', w6,
                    'TaxAmount', w6,
                    'TotalAmount', w6,
                    'DiamondPieces', w3,
                    'DiamondWeight', w6,
                    'StonePieces', w3,
                    'StoneWeight', w6,
                    'OtherPieces', w3,
                    'OtherWeight', w6
                ]);
            }
        }
    }
}
